import { Help } from '@plasma/ui.application.app';

const help: Help[] = [
  // {
  //   title: 'CurrentRfqStatus',
  //   description: 'description of CurrentRfqStatus',
  //   url: '/current-rfq-status',
  // },
];

export default help;
